module.exports = __webpack_public_path__ + "fonts/4961640c9a04f7dde81f3c1259130f3f.svg";